// Get configuration from window.ENV (loaded from config.js) or import.meta.env for local development
export const getConfig = (key: string): string => {
  return (window as any).ENV?.[key] || import.meta.env[key] || '';
};

// Ensure we always have a valid API_URL, even if config hasn't loaded yet
export const API_URL = (() => {
  const configValue = getConfig('VITE_API_URL');
  if (configValue) return configValue;

  // Fallback based on hostname
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:7073';
  }

  // Default fallback
  return 'http://localhost:7073';
})();